import Model from "@/lib/model/model";

export class QuestionnaireEvaluate extends Model {
  resultLevel = 0;
  result = "";
  resultDesc = "";
}

export class ObvervationalEvaluateList extends Model {
  resultLevel = 0;
  description = "";
  evaluateResult = "";
  evaluateResultDesc = "";
  id = 2;
  match = false;
  name = "";
}

export class DimensionEvaluateList extends Model {
  evaluateResultLevel = 0;
  description = "";
  evaluateResult = "";
  evaluateResultDesc = "";
  id = 0;
  name = "";
}

export class TacPsycResult extends Model {
  questionnaireEvaluate = new QuestionnaireEvaluate();
  obvervationalEvaluateList = [new ObvervationalEvaluateList()];
  dimensionEvaluateList = [new DimensionEvaluateList()];

  get obvervationalEvaluateShowList() {
    return this.obvervationalEvaluateList.filter(item => item.match);
  }
}

export class TacPsyc extends Model {
  isFinish = 0;
  psycGaugeId = 0; // 量表id 1 dvf
  result = new TacPsycResult();
}
